
    <label class="customised-control">
      <input type="checkbox" class="customised-control-input"
             [disabled]="disabled"
             [checked]="value"
             (change)="value = !value"
             (blur)="setTouched()">
      <span class="customised-control-indicator"></span>
      <span class="customised-control-description">
        <ng-content></ng-content>
      </span>
    </label>
  